import React, { Component } from "react";
import api from "../../../services/api";

import Base from "../../../components/Base";
import { Alert } from "antd";

import Formulario from "./Formulario";

import * as Permissions from "../../../services/permissions";

import "../styles.css";
import Loading from "../../../components/Loading";

export default class Create extends Component {
  state = {
    loading: true,
    pasta: null,
    error: null
  };

  componentDidMount() {
    /** Pega informações da pasta */
    this.handleInformations();
  }

  /** Busca informações da pasta */
  handleInformations = async () => {
    const { id } = this.props.match.params;

    console.log("aqui");
    await api
      .get(`/pasta/pastas/${id}/`)
      .then(response => {
        this.setState({
          pasta: response.data,
          loading: false
        });
      })
      .catch(error => {
        let message = "Não foi possível obter informações da pasta.";
        if (error.response) {
          if (error.response.status == 404) {
            message = "Pasta não encontrada.";
          }
        }
        this.setState({
          error: message,
          loading: false
        });

        console.log(error);
      });
    console.log("aqui");
  };

  render() {
    /** Loading */
    if (this.state.loading) {
      return <Loading />;
    }

    /** Error */
    if (this.state.error) {
      return (
        <Base
          title="Cadastrar acordo"
          extra={[
            <div key={1} className="acordo__header_pasta">
              Pasta: <b>{this.state.pasta ? this.state.pasta.pasta : "..."}</b>
            </div>
          ]}
        >
          <Alert type="error" message={this.state.error} />
        </Base>
      );
    }

    /** User permission */
    if (!Permissions.has(Permissions.ACORDO_CREATE)) {
      return (
        <Base
          title="Cadastrar acordo"
          extra={[
            <div key={1} className="acordo__header_pasta">
              Pasta: <b>{this.state.pasta ? this.state.pasta.pasta : "..."}</b>
            </div>
          ]}
        >
          <Alert
            type="warning"
            message="Você não possui permissão para cadastrar acordos."
          />
        </Base>
      );
    }
    return (
      <Base
        title="Cadastrar acordo"
        extra={[
          <div key={1} className="acordo__header_pasta">
            Pasta:{" "}
            <b>{this.state.pasta ? `${this.state.pasta.pasta}` : "..."}</b>
          </div>
        ]}
      >
        {/** Renderiza o formulário do acordo */}
        <Formulario pasta={this.state.pasta} />
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/Create/index.js